module.exports = __webpack_public_path__ + "img/dj.79c7d969.svg";